<template>
  <el-row type="flex" class="about-row" justify="space-between">
    <div class="about-left">
      <!--<div class="about-title">About us</div>-->
      <el-tabs>
        <el-tab-pane
          label="产品系列"
          lazy
          @mouseenter.native="mouseEnter"
          @mouseleave.native="mouseLeave"
        >
          <swiper
            v-if="productList.length"
            :options="productOption"
            ref="productSwiper"
          >
            <swiper-slide
              v-for="(item, index) of productList"
              :key="'product-' + index"
            >
              <div class="imgoutdiv">
                <img :src="item.image" />
              </div>
              <div class="swiper_bor">
                <div class="swiper_title">{{ item.name_ch }}</div>
                <div class="swiper_content">{{ item.remark | getText }}</div>
                <button
                  class="more productListmore"
                  :data-obj="JSON.stringify(item)"
                >
                  查看详情
                </button>
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="btn btn-prev"
            @click="$refs.productSwiper.$swiper.slidePrev()"
            v-show="btnShow"
          ></div>
          <div
            class="btn btn-next"
            @click="$refs.productSwiper.$swiper.slideNext()"
            v-show="btnShow"
          ></div>
        </el-tab-pane>
        <el-tab-pane
          label="业务系列"
          lazy
          @mouseenter.native="mouseEnter"
          @mouseleave.native="mouseLeave"
        >
          <swiper
            v-if="businessList.length"
            :options="businessOption"
            ref="businessSwiper"
          >
            <swiper-slide
              v-for="(item, index) of businessList"
              :key="'business-' + index"
            >
              <div class="imgoutdiv">
                <img :src="item.image" />
              </div>
              <div class="swiper_bor">
                <div class="swiper_title">{{ item.name_ch }}</div>
                <div class="swiper_content">{{ item.remark | getText }}</div>
                <button
                  class="more businessListmore"
                  :data-obj="JSON.stringify(item)"
                >
                  查看详情
                </button>
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="btn btn-prev"
            @click="$refs.businessSwiper.$swiper.slidePrev()"
            v-show="btnShow"
          ></div>
          <div
            class="btn btn-next"
            @click="$refs.businessSwiper.$swiper.slideNext()"
            v-show="btnShow"
          ></div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="about-right" :class="{ moveup: isActive, movedown: !isActive }">
      <el-row>
        <el-col :span="24">
          <h2 class="about_h2">关于我们</h2>
          <p class="under-line"></p>
          <p class="about_p">
            浙江销巴科技有限公司（Zhejiang Shall Buy Technology
            Co.,Ltd.），成立于2013年12月18日，是一家集人才孵化、电商服务、网络技术等于一体的互联网科技公司。公司立足于电子商务领域，专注打造新型消费模式，以国家政策为导向，高举“分享经济”旗帜，促进“消费者”逐步转变为“消费商”。公司始终坚持刚需消费方向，以消费增值理念推动共同富裕目标的实现，致力于打造一个绿色、健康、稳健的消费增值服务平台。
          </p>

          <el-row class="about_btn">
            <el-button type="danger" @click="goAbout">
              详情介绍
              <img src="../../assets/home/route1.png" alt />
            </el-button>
            <el-button @click="goContact">
              <img src="../../assets/home/contact.png" alt />
              联系方式
            </el-button>
          </el-row>
        </el-col>
      </el-row>
      <div class="about_video">
        <video-player
          :options="playerOptions"
          class="vjs-custom-skin"
          :playsinline="true"
        ></video-player>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="991px"
      :title="showData.name_ch"
    >
      <div class="dialogContent">
        <div
          class="dialogImg"
          v-if="
            showData.notification_images &&
            showData.notification_images.length > 0
          "
        >
          <swiper
            v-if="showData.notification_images.length"
            :options="notificationImagesOption"
            ref="notificationImagesSwiper"
          >
            <swiper-slide
              v-for="(item, index) of showData.notification_images"
              :key="index"
            >
              <div class="dialogInImage">
                <el-image
                  style="width: 225px; height: 400px"
                  :src="item"
                  fit="cover"
                ></el-image>
              </div>
            </swiper-slide>
          </swiper>
          <img
            src="./../../assets/home/prev3.png"
            class="swiper-button-prev"
            @click="$refs.notificationImagesSwiper.$swiper.slidePrev()"
            alt=""
            v-if="showSlidePrev"
          />
          <img
            src="./../../assets/home/next3.png"
            class="swiper-button-next"
            @click="$refs.notificationImagesSwiper.$swiper.slideNext()"
            alt=""
            v-if="showSlideNext"
          />
        </div>
        <div v-html="showData.remark" class="claim-p"></div>
      </div>
      <div
        v-if="showData.jump_url && showData.jump_url.length > 0"
        class="dialogButtom"
      >
        <a
          :href="item.url"
          target="_blank"
          v-for="(item, index) of showData.jump_url"
          :key="index"
          >{{ item.name }}</a
        >
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
const proBusAllUri = "website/index/pro/bus/get/all";

let vm = null;
export default {
  data() {
    return {
      isActive: false,
      productOption: {
        slidesPerView: 3,
        spaceBetween: 27,
        loop: false,
        on: {
          // init: function () {
          //   vm.productinitEvent();
          // },
        },
      },
      productList: [],
      businessOption: {
        slidesPerView: 3,
        spaceBetween: 27,
        loop: false,
        on: {
          // init: function () {
          //   vm.businessinitEvent();
          // },
        },
      },
      businessList: [],
      playerOptions: {
        height: "320",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        // poster:
        //   "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg" //视频播放前放的照片，可自己调整
      },
      dialogVisible: false,
      showData: {},
      btnShow: false,
      notificationImagesOption: {
        slidesPerView: 3.7,
        spaceBetween: 20,
        loop: false,
      },
      showSlidePrev: false,
      showSlideNext: false,
    };
  },
  created() {
    vm = this;
    this.initVideo();
    this.getProBusAll();
  },
  filters: {
    // 获取文本内容
    getText(str) {
      if (str.indexOf("<") == -1) {
        return str;
      } else {
        let result = "";
        let flag = false;
        for (let char of str) {
          if (char === ">") {
            flag = true;
          }
          if (char === "<") {
            flag = false;
          }
          if (flag && char !== ">") {
            result =
              result.replace(/&nbsp;/g, "") + char.replace(/&nbsp;/g, "");
          }
        }
        return result;
      }
    },
  },
  methods: {
    mouseEnter() {
      this.btnShow = true;
    },
    mouseLeave() {
      this.btnShow = false;
    },
    // 初始化视频
    initVideo() {
      let config = this.$cache.get("basicConfig");
      if (config) {
        this.playerOptions.sources = [
          {
            src: config.video,
          },
        ];
      }
    },
    goAbout() {
      this.$router.push("/about");
    },
    goContact() {
      this.$router.push("/amap");
    },
    // 获取所有产品业务
    getProBusAll() {
      this.getProductAll();
      this.getBusinessAll();
    },
    // 获取所有产品
    getProductAll() {
      this.$api
        .get(proBusAllUri, {
          pro_bus: 1,
        })
        .then((res) => {
          if (res.list.length > 2) {
            this.productOption.loop = true;
          }
          this.productList = res.list;
          this.productOption.on = {
            click() {
              let index = this.clickedIndex - this.activeIndex + this.realIndex;
              vm.productinitEvent(index);
            },
          };
        });
    },
    // 获取所有业务
    getBusinessAll() {
      this.$api
        .get(proBusAllUri, {
          pro_bus: 2,
        })
        .then((res) => {
          if (res.list.length > 2) {
            this.businessOption.loop = true;
          }
          this.businessList = res.list;
          this.businessOption.on = {
            click() {
              let index = this.clickedIndex - this.activeIndex + this.realIndex;
              vm.businessinitEvent(index);
            },
          };
        });
    },

    // 产品点击事件
    productinitEvent(e) {
      let index = e;
      if (index == this.productList.length) {
        index = 0;
      } else if (index == this.productList.length + 1) {
        index = 1;
      } else if (index == this.productList.length + 2) {
        index = 2;
      }
      this.showData = this.productList[index];
      this.showItem();
    },
    // 业务点击事件
    businessinitEvent(e) {
      let index = e;
      if (index == this.businessList.length) {
        index = 0;
      } else if (index == this.businessList.length + 1) {
        index = 1;
      } else if (index == this.businessList.length + 2) {
        index = 2;
      }
      this.showData = this.businessList[index];
      this.showItem();
    },
    showItem() {
      this.showSlideNext = false;
      this.showSlidePrev = false;
      this.dialogVisible = true;
      if (this.showData.notification_images.length > 3) {
        this.showSlideNext = true;
      }
      this.notificationImagesOption.on = {
        transitionEnd() {
          if (this.isEnd) {
            vm.showSlideNext = false;
          } else {
            vm.showSlideNext = true;
          }
          if (this.activeIndex > 0) {
            vm.showSlidePrev = true;
          } else {
            if (
              !vm.showSlideNext &&
              vm.showData.notification_images.length == 4
            ) {
              vm.showSlidePrev = true;
            } else {
              vm.showSlidePrev = false;
            }
          }
        },
      };
    },
  },
  mounted() {
    window.addEventListener("scroll", () => {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= 200) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    });
  },
};
</script>
<style lang="less">
.about-row {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  h1 {
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 15px;
    padding: 0 36px;
    line-height: 30px;
  }
  .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }
  .el-dialog__header {
    padding: 20px 48px;
    .el-dialog__title {
      font-size: 20px;
    }
  }
  .el-dialog__body {
    border-top: 1px solid #eeeeee;
    padding: 0;
    position: relative;
  }
  .dialogContent {
    padding: 0px 48px 80px;
    max-height: 625px;
    overflow: auto;
    .claim-p {
      font-size: 16px;
      color: #555555;
      line-height: 22px;
      margin: 32px 0;
    }
    .dialogImg {
      position: relative;
      margin-top: 32px;
      .dialogInImage {
        img {
          border-radius: 4px;
        }
      }
      .swiper-button-prev {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 6px;
      }
      .swiper-button-next {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 6px;
      }
    }
  }
  .dialogButtom {
    box-shadow: 0px -0.5px 15px #f9f2f0;
    height: 80px;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #ffffff;
    padding: 0 48px;
    border-radius: 0 0 8px 8px;
    a {
      margin-right: 10px;
      height: 30px;
      line-height: 30px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      color: #ff5619;
      padding: 0 12px;
      border: 1px solid #ff5619;
    }
  }
  .about-left {
    width: 628px;
    position: relative;
    .el-tabs {
      .el-tabs__header {
        // margin: 136px 0 0 48px;
        margin-left: 48px;
        margin-top: 139px;
        .el-tabs__nav-wrap::after {
          height: 0;
        }
        .el-tabs__item {
          font-size: 30px;
          height: 60px;
          opacity: 0.2;
          font-weight: 500;
          color: #333;
        }
        .is-active {
          opacity: 1;
        }
      }
      .el-tabs__content {
        position: relative;
        margin-top: 44px;
        .swiper-container {
          margin: 0px 32px 0 32px;
          .swiper-slide {
            font-size: 0;
            .imgoutdiv {
              width: 170px;
              height: 170px;
              img {
                max-width: 170px;
                transform: translateY(-50%);
                margin-top: 85px;
              }
            }
            .swiper_bor {
              border: 1px solid #eeeeee;
              border-radius: 0 0 2px 2px;
              padding: 6px 11px 14px;
              .swiper_title {
                font-size: 18px;
                font-weight: 500;
                color: #333;
                line-height: 38px;
                overflow: hidden;
                display: -webkit-box; //将元素设为盒子伸缩模型显示
                -webkit-box-orient: vertical; //伸缩方向设为垂直方向
                -webkit-line-clamp: 1; //超出3行隐藏，并显示省略号
              }
              .swiper_content {
                font-size: 14px;
                color: #555555;
                height: 52px;
                line-height: 26px;
                overflow: hidden;
                display: -webkit-box; //将元素设为盒子伸缩模型显示
                -webkit-box-orient: vertical; //伸缩方向设为垂直方向
                -webkit-line-clamp: 2; //超出3行隐藏，并显示省略号
              }
              .more {
                font-size: 14px;
                color: #e60616;
                height: 24px;
                line-height: 28px;
                padding: 0;
                border: none;
                background-color: #ffffff;
                // img {
                //   width: 15px;
                //   height: 5px;
                //   vertical-align: middle;
                //   margin-left: 8px;
                // }
              }
            }
          }
        }
        .btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 32px;
          height: 64px;
          cursor: pointer;
          z-index: 2;
        }
        .btn-prev {
          left: 0;
          background-image: url("../../assets/home/prev2.png");
          background-size: 100% 100%;
        }
        .btn-next {
          right: 0;
          background-image: url("../../assets/home/next2.png");
          background-size: 100% 100%;
        }
      }
    }
    .about-title {
      position: absolute;
      right: 0;
      width: 195px;
      height: 195px;
      line-height: 195px;
      text-align: center;
      color: #c0c0c0;
      background: #f2f2f2;
    }
  }
  .about-right {
    width: 572px;
    background: #fff;
    .el-row {
      padding: 48px 44px 38px 44px;
      .about_h2 {
        font-size: 30px;
        font-weight: 500;
        color: #333;
      }
      .under-line {
        width: 24px;
        height: 2px;
        background: #e60616;
        margin-top: 30px;
      }
      .about_p {
        font-size: 16px;
        line-height: 30px;
        color: #555555;
        margin-top: 12px;
      }
      .about_btn {
        padding: 0;
        margin-top: 43px;
        .el-button {
          width: 159px;
          height: 53px;
        }
        .el-button--danger {
          background: #e60616;
          span {
            font-size: 16px;
            font-weight: 500;
            color: #fff;
            img {
              width: 15px;
              height: 3px;
              vertical-align: middle;
            }
          }
        }
        .el-button--default {
          border: 1px solid #e60616;
          margin-left: 16px;
          span {
            font-size: 16px;
            font-weight: 500;
            color: #e60616;
            line-height: 21px;
            img {
              width: 22px;
              height: 21px;
              vertical-align: middle;
            }
          }
        }
      }
    }
    .about_video {
      .vjs-poster {
        background-size: 100% 100%;
      }
    }
  }
  .moveup {
    margin-top: -150px;
    transition: all 1.3s ease 0.2s;
    z-index: 2;
  }
  .movedown {
    margin-top: 0;
    transition: all 1.3s ease 0.2s;
    z-index: 2;
  }
}
.el-tabs__active-bar {
  background: #e60616;
}
</style>